// File: src/emura-edition/pages/OurLibrary.jsx

import React, { useState } from "react";
import { Link } from "react-router-dom";

const newBooks = [
    {
        id: 1,
        title: "Coloriages mystères - Schtroumpfs Tome 2",
        image: "https://m.media-amazon.com/images/I/81EYWcB3HgL._AC_UL320_.jpg",
        price: "15,95€",
    },
    {
        id: 2,
        title: "Solo Leveling T18",
        image: "https://m.media-amazon.com/images/I/81CkJdAh1rL._AC_UL320_.jpg",
        price: "14,95€",
    },
    {
        id: 3,
        title: "Réussir en maths 2de avec Lucas",
        image: "https://m.media-amazon.com/images/I/51bLS7SxzTL._AC_UL320_.jpg",
        price: "13,90€",
    },
    {
        id: 4,
        title: "Coloriages mystères Disney - Chevaux",
        image: "https://m.media-amazon.com/images/I/71U8nm19KJL._AC_UL320_.jpg",
        price: "14,95€",
    },
];

const bestRatedBooks = [
    {
        id: 5,
        title: "Grand ménage XXL",
        image: "https://m.media-amazon.com/images/I/71JvJ0dO9RL._AC_UL320_.jpg",
        price: "15,95€",
    },
    {
        id: 6,
        title: "Code civil 2026 annoté",
        image: "https://m.media-amazon.com/images/I/41+ppE1RZBL._AC_UL320_.jpg",
        price: "22,00€",
    },
    {
        id: 7,
        title: "Ton Ange Gardien",
        image: "https://m.media-amazon.com/images/I/61FlPGE09IL._AC_UL320_.jpg",
        price: "11,60€",
    },
    {
        id: 8,
        title: "Réussir son code de la route",
        image: "https://m.media-amazon.com/images/I/81eySxfr+nL._AC_UL320_.jpg",
        price: "18,50€",
    },
];

function BookCarousel({ title, books }) {
    const [startIndex, setStartIndex] = useState(0);
    const itemsPerPage = 4;

    const next = () => {
        setStartIndex((prev) => (prev + itemsPerPage) % books.length);
    };

    const prev = () => {
        setStartIndex((prev) => (prev - itemsPerPage + books.length) % books.length);
    };

    const visible = books
        .slice(startIndex, startIndex + itemsPerPage)
        .concat(
            books.slice(0, Math.max(0, startIndex + itemsPerPage - books.length))
        );

    return (
        <div className="mb-12">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold">{title}</h2>
                <button className="text-blue-600 hover:underline text-sm">Voir plus</button>
            </div>

            <div className="relative">
                <button
                    onClick={prev}
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 hover:bg-gray-300 p-2 rounded-full z-10"
                >
                    ◀
                </button>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 px-10">
                    {visible.map((book) => (
                        <Link
                            key={book.id}
                            to={`/book/${book.id}`}
                            className="bg-white rounded-lg overflow-hidden shadow hover:shadow-lg transition block"
                        >
                            <img
                                src={book.image}
                                alt={book.title}
                                className="w-full h-64 object-contain p-4 hover:scale-105 transition-transform duration-300"
                            />
                            <div className="p-4">
                                <h3 className="text-md font-medium">{book.title}</h3>
                                <p className="text-gray-700 font-semibold">{book.price}</p>
                            </div>
                        </Link>
                    ))}
                </div>

                <button
                    onClick={next}
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 hover:bg-gray-300 p-2 rounded-full z-10"
                >
                    ▶
                </button>
            </div>
        </div>
    );
}

export default function OurLibrary() {
    return (
        <div className="bg-white text-black px-6 py-12">
            <div className="max-w-7xl mx-auto">
                <BookCarousel title="Nouveautés" books={newBooks} />
                <BookCarousel title="Les mieux notés" books={bestRatedBooks} />
            </div>
        </div>
    );
}
